<template>
  <div>
    <!-- 外部链接进入招商大脑通过此页面 转发到要去的地址 -->
       <!-- 登录失败提示 -->
        <el-dialog
          title=""
          :visible.sync="dialogVisible"
          width="30%"
          top="25vh"
          >
          <div class="dialog-content">
            <i class="el-icon-warning errorIcon"></i>
            <p class="dialog-title font-weight">登录失败</p>
            <p>{{ error }}</p>
          </div>
          <!-- <div class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleClose">确定</el-button>
          </div> -->
        </el-dialog>
  </div>
</template>

<script>

export default {
data() {
    return {
      logindata: {
        token: "",
        path: "",
        ref: ""
      },
      error : '',
      dialogVisible: false,
    };
  },
created() {
    this.logindata.path = this.$route.query.path;
    this.logindata.token = this.$route.query.token;
    console.log('this.logindata',this.logindata);
    if (this.logindata.token && this.logindata.path) { //
       this.passwordLogin();
		}

},
methods: {
  handleClose() {
    this.dialogVisible = false;
  },
  passwordLogin() { 
		var that = this;
		var loginurl = this.$api.user.user.login();
		this.bus.$emit('loading', true);
    // user-login?token=' + that.logindata.token+'&refer="projectmanagement",
    //加密atob
    if(this.logindata.path == 'index'){
      this.logindata.ref = 'homePage';
    }else if(this.logindata.path == 'project'){
      this.logindata.ref = 'findProjects';
    }else if(this.logindata.path == 'infomation'){
      this.logindata.ref = 'hometownInvestment';
    }
    let loginToken =  window.btoa(this.logindata.token);
    let loginRefer =   window.btoa(this.logindata.ref);
    console.log('loginurl',loginToken,loginRefer);
		// +'?username='+this.logindata.username+'&password='+this.logindata.password+'&client=1' 
		// $.ajax({
		// 	type: "post",
		// 	url: loginurl,
		// 	data: this.logindata,
		// 	success: function (res) {
		// 		var resdata = res;
		// 		console.log('登陆返回', resdata);
		// 		// resdata.success=false;
		// 		// resdata.msg='用户过期123';
		// 		// resdata.data='2024-2-21';
		// 		// resdata.code = 100102;
		// 		if (resdata.success) {
          switch (that.logindata.path) {
                case "index": //招商大脑
                   window.location.href = 'https://zhaoshangdanao.com/#/user-login?token='+loginToken+'&refer='+loginRefer;
                    break;
                case "project": //项目管理系统
                    window.location.href = 'https://xm.zhaoshangdanao.com/#/user-login?token='+loginToken+'&refer='+loginRefer;
                    break;
                case "infomation": //信息库
                    window.location.href = 'https://zhaoshangdanao.com/#/user-login?token='+loginToken+'&refer='+loginRefer;
                    break;
                default:
                  that.routerself('/totalEnterprises');
            }
				// } else {
				// 	that.bus.$emit('loading', false);
        //   that.error = resdata.msg;
        //   that.dialogVisible = true;
        //   // that.$message({
				// 	// 	type: 'error',
				// 	// 	message: res.msg,
				// 	// });
				// }
			// }
		// })
	},
},
}
</script>

<style lang="scss" scoped>
.dialog-content{
  text-align: center;
  font-size: 18px;
  margin: 25px;
  padding: 40px 10px;
  border-radius: 10px;
  background-color: #f4f9fd;
  .dialog-title{
    margin-top: 20px;
    font-size: 20px;
  }
}
.errorIcon{
  color: #f56c6c;
  font-size: 60px;
}
.dialog-title{
  margin-bottom: 10px;
}
</style>